import {API} from "aws-amplify";
import {GRAPHQL_AUTH_MODE, GraphQLQuery} from "@aws-amplify/api";
import {HandleOemMatchQuery, HandleOemMatchQueryVariables} from "../../API";
import * as queries from "../../graphql/queries";
import aws_config from "../../modified_aws-export";
import {toast} from "react-toastify";
import {matchActions, partPositionDatabaseNamespaceValue} from "../../types/common";

export const matchToOEM = async (
    match_type: string,
    file_name: string,
    t: any,
    selectedNameSpace: string = "",
    oem_file_name: string = "",
    metadata: string = ""
) => {
    let databaseNamespace = 
    selectedNameSpace === "BtlAll" || 
    selectedNameSpace === "BtlSingle"
    ? partPositionDatabaseNamespaceValue
    : null;

    try {
        const result = await API.graphql<GraphQLQuery<HandleOemMatchQuery>>({
            query: queries.handleOemMatch,
            variables: {
                action: match_type,
                ta_file_name: file_name,
                oem_hash_file_name: oem_file_name,
                bucket: aws_config.aws_user_files_s3_bucket,
                backend_bucket: aws_config.backend.bucket_name,
                metadata: metadata,
                aim_model_name: "aim-600M-2B-imgs",
                aim_task_name: "TecRMIAIMModel",
                namespace: databaseNamespace,
                vit_model_name: "vit_small_patch16_224",
                vit_task_name: "TecRMI",
            } as HandleOemMatchQueryVariables,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        });

        if (!result.data?.handleOemMatch) {
            return sendErrorMessageForHandleOemMatch(match_type, t);
        }

        const parsed_response = JSON.parse(result.data.handleOemMatch);
        if (parsed_response?.message === "Successful finished") {
            return handleSuccessMessage(match_type, t);
        }
        return sendErrorMessageForHandleOemMatch(match_type, t);
    } catch (error: any) {
        console.error(error);
        toast(error.errors || "An unexpected error occurred", {type: "error"});
    }
};

const handleSuccessMessage = (match_type: string, t: any) => {
    if (match_type === matchActions.match) {
        toast(t("MatchFunctionality.MatchSuccessfulMessage"), {type: "success"});
    } else if (match_type === matchActions.unmatch) {
        toast(t("MatchFunctionality.UnmatchSuccessfulMessage"), {type: "success"});
        return "success";
    }
};

const sendErrorMessageForHandleOemMatch = (match_type: string, t: any) => {
    const messageKey = match_type === matchActions.match
        ? "MatchFunctionality.MatchFailureMessage"
        : "MatchFunctionality.UnmatchFailureMessage";
    toast(t(messageKey), {type: "error"});
};
